<template>
  <doughnut :chartData="graphData" :options="options" ref="skills_chart" :height="350" :width="350" />
</template>

<script>
import randomcolor from 'randomcolor';
import Doughnut from './Doughnut.vue';
export default {
  name: 'ReportGraph',
  props: {
    chartData: Array,
    chartId: String,
    labelPropName: {
      default: 'name',
      type: String,
    },
    dataPropName: {
      default: 'count',
      type: String,
    },
    showDataLabels: {
      default: true,
      type: Boolean,
    },
  },
  components: { Doughnut },
  data() {
    return {
      graphData: {},
      options: {
        legend: {
          display: this.showDataLabels,
          labels: { boxWidth: 15 },
        },
        responsive: false,
        maintainAspectRatio: false,
        animation: {
          animateRotate: false,
        },
      },
    };
  },
  created() {
    this.options.legend.display = this.showDataLabels;
  },
  methods: {
    updateChart() {
      this.$refs.skills_chart.update();
    },
  },
  watch: {
    chartData: {
      deep: true,
      immediate: true,
      handler(val, oldVal) {
        this.graphData = {
          labels: [this.chartId],
          labels: val.map(({ [this.labelPropName]: label }) => label),
          datasets: [{ backgroundColor: val.map(() => randomcolor()), data: val.map(({ [this.dataPropName]: dataPoint }) => dataPoint) }],
        };
        this.updateChart();
      },
    },
  },
};
</script>
<style lang="scss" scoped></style>
